import { render, staticRenderFns } from "./historialClinicaInternacion.vue?vue&type=template&id=5ec98b65&scoped=true&"
import script from "./historialClinicaInternacion.vue?vue&type=script&lang=js&"
export * from "./historialClinicaInternacion.vue?vue&type=script&lang=js&"
import style0 from "./historialClinicaInternacion.vue?vue&type=style&index=0&id=5ec98b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec98b65",
  null
  
)

export default component.exports